"use strict";
// To be cleansed of IoTV accounts in external-edition
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountDef = exports.pollingAccountConfigs = exports.sharedServiceAccounts = exports.LNCTestAccountConfigDef = exports.LNCAccountConfigDef = exports.delegationAccounts = void 0;
/** List of accounts used in role creation: top level customer account allows these sub accounts to assume Route53 actions roles  */
exports.delegationAccounts = {
    'ssac-prod': '371246242425',
    'c021-2-dev': '350765540072',
    'c021-2-prod': '419505150506',
    'c021-2-test': '000488367925',
    'i301-2-dev': '983633894134',
    'i301-2-test': '976362983261',
    'iotv-test': '339712843844',
    'v001-dev': '493807289778',
    'n016-prod': '514307174634',
    'v010-dev': '108782065602',
    'v010-test': '265613950789',
    'v010-prod': '691443742112',
    'v013-2-dev': '390614971258',
    'v015-2-dev': '825568837076',
    'v015-2-test': '845267537230',
    'v015-2-prod': '417233790143',
    'v016-2-dev': '792399701743',
    'v016-2-prod': '879930654422',
    'v016-2-test': '439403196313',
    'v020-2-dev': '624505960450',
    'v020-2-test': '155987728800',
    'v020-2-prod': '994792859563',
    'v021-dev': '277707136507',
    'v021-test': '160885263523',
    'v021-prod': '585008046143',
    'v022-dev': '727646466617',
    'v023-dev': '331355389556',
    'v024-prod': '488479523940',
};
exports.LNCAccountConfigDef = { accountId: '371246242425', projectCode: 'ssac', stage: 'prod', region: 'ap-southeast-2' };
exports.LNCTestAccountConfigDef = { accountId: '326269142550', projectCode: 'ssac', stage: 'dev', region: 'ap-southeast-2' };
/** Required in external-edition, do not remove during merge */
exports.sharedServiceAccounts = [
    exports.LNCAccountConfigDef,
    exports.LNCTestAccountConfigDef
];
// To be cleansed of IoTV accounts in external-edition
exports.pollingAccountConfigs = [
    exports.LNCAccountConfigDef,
    { accountId: '350765540072', projectCode: 'c0212', stage: 'dev', region: 'ap-southeast-2' },
    { accountId: '000488367925', projectCode: 'c0212', stage: 'test', region: 'ap-southeast-2' },
    { accountId: '419505150506', projectCode: 'c0212', stage: 'prod', region: 'ap-southeast-2' },
    { accountId: '983633894134', projectCode: 'i3012', stage: 'dev', region: 'ap-southeast-2' },
    { accountId: '976362983261', projectCode: 'i3012', stage: 'test', region: 'ap-southeast-2' },
    { accountId: '339712843844', projectCode: 'iotv', stage: 'test', region: 'ap-southeast-2' },
    { accountId: '514307174634', projectCode: 'n016', stage: 'prod', region: 'ap-southeast-2' },
    { accountId: '493807289778', projectCode: 'v001', stage: 'dev', region: 'ap-southeast-2' },
    { accountId: '108782065602', projectCode: 'v010', stage: 'dev', region: 'ap-southeast-2' },
    { accountId: '265613950789', projectCode: 'v010', stage: 'test', region: 'ap-southeast-2' },
    { accountId: '691443742112', projectCode: 'v010', stage: 'prod', region: 'ap-southeast-2' },
    { accountId: '390614971258', projectCode: 'v0132', stage: 'dev', region: 'ap-southeast-2' },
    { accountId: '825568837076', projectCode: 'v0152', stage: 'dev', region: 'ap-southeast-2' },
    { accountId: '845267537230', projectCode: 'v0152', stage: 'test', region: 'ap-southeast-2' },
    { accountId: '417233790143', projectCode: 'v0152', stage: 'prod', region: 'ap-southeast-2' },
    { accountId: '792399701743', projectCode: 'v0162', stage: 'dev', region: 'ap-southeast-2' },
    { accountId: '439403196313', projectCode: 'v0162', stage: 'test', region: 'ap-southeast-2' },
    { accountId: '879930654422', projectCode: 'v0162', stage: 'prod', region: 'ap-southeast-2' },
    { accountId: '624505960450', projectCode: 'v0202', stage: 'dev', region: 'ap-southeast-2' },
    { accountId: '155987728800', projectCode: 'v0202', stage: 'test', region: 'ap-southeast-2' },
    { accountId: '994792859563', projectCode: 'v0202', stage: 'prod', region: 'ap-southeast-2' },
    { accountId: '277707136507', projectCode: 'v021', stage: 'dev', region: 'ap-southeast-2' },
    { accountId: '160885263523', projectCode: 'v021', stage: 'test', region: 'ap-southeast-2' },
    { accountId: '585008046143', projectCode: 'v021', stage: 'prod', region: 'ap-southeast-2' },
    { accountId: '727646466617', projectCode: 'v022', stage: 'dev', region: 'ap-southeast-2' },
    { accountId: '331355389556', projectCode: 'v023', stage: 'dev', region: 'ap-southeast-2' },
    { accountId: '488479523940', projectCode: 'v024', stage: 'prod', region: 'ap-southeast-2' },
];
const getAccountDef = (projectCode, stage) => {
    let res = exports.pollingAccountConfigs.find((acc) => acc.projectCode === projectCode && acc.stage === stage) ?? null;
    return res;
};
exports.getAccountDef = getAccountDef;
